import { envConfig } from "../env";
import type { MarketConfiguration } from "./const";
import {
  ContentfulEnum,
  CurrencyEnum,
  ElevateMarketEnum,
  LocaleEnum,
  MarketEnum,
  RegionEnum,
  ServiceLocaleEnum,
} from "./const";

const norway: MarketConfiguration = {
  code: MarketEnum.no,
  label: "Norway",
  descriptiveLabel: "Norwegian",
  testfreaksClientId: envConfig.NEXT_PUBLIC_NO_TESTFREAKS_CLIENT_ID,
  searchEngineUrl: envConfig.NEXT_PUBLIC_SEARCH_ENGINE_URL_NO,
  contentfulLocale: ContentfulEnum.no,
  contentfulCountry: "Norway",
  locale: LocaleEnum.no,
  serviceLocale: ServiceLocaleEnum.no,
  language: {
    code: "nb",
    label: "Norwegian",
    flag: "no",
  },
  currency: CurrencyEnum.nok,
  link: "https://www.nordiskagalleriet.no",
  termsSlug: "kjopsvilkar-online",
  loop54Market: MarketEnum.no,
  adyenMarket: MarketEnum.no,
  elevateMarket: ElevateMarketEnum.no,
  freeShippingThreshold: 1000,
  freeShippingEnabled: false,
  externalStoreId: "ecom-no",
  searchPathName: "sog",
  adyenCheckoutEnabled: false,
  walleyCheckoutEnabled: true,
  walleyB2CStoreId: envConfig.NEXT_PUBLIC_WALLEY_STORE_CODE_B2C_NO,
  walleyB2BStoreId: envConfig.NEXT_PUBLIC_WALLEY_STORE_CODE_B2B_NO,
  walleyWidgetEnabled: true,
  hasTrustPilot: false,
  region: RegionEnum.nordics,
  intraRegionOrder: 1,
  norceImageCdn: ["local", "dev", "stage"].includes(
    process.env.NEXT_PUBLIC_ENVIRONMENT ?? "",
  )
    ? "https://media.stage.cdn-norce.tech/1413"
    : "https://cdn.nordiskagalleriet.no",
  eurobonus: true,
  eurobonusThreshold: 5000,
};

export default norway;
